import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { ProtocoloPesquisaRequest, ProtocoloResponse, ProtocoloSelecaoResponse, ProtocoloTipoResponse } from '@/core/api/sicom-api/protocolos/protocolo.model';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class ProtocoloService extends BaseService {
    readonly PATH = environment.basePath + '/protocolos';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    buscar(idProtocolo: number, context?: HttpContext): Observable<ProtocoloResponse> {
        return this.http.get<ProtocoloResponse>(`${this.PATH}/${idProtocolo}`, { context });
    }

    listarTipos(context?: HttpContext): Observable<ProtocoloTipoResponse[]> {
        return this.http.get<ProtocoloTipoResponse[]>(`${this.PATH}/tipos`, { context });
    }

    pesquisar(request: ProtocoloPesquisaRequest, context?: HttpContext): Observable<ProtocoloSelecaoResponse[]> {
        let params = new HttpParams();

        if (request.idTipoProtocolo !== undefined && request.idTipoProtocolo !== null && request.idTipoProtocolo > 0) {
            params = params.set('idTipoProtocolo', String(request.idTipoProtocolo));
        }

        if (request.nuProtocolo !== undefined && request.nuProtocolo !== null && request.nuProtocolo > 0) {
            params = params.set('nuProtocolo', String(request.nuProtocolo));
        }

        if (request.nuAnoProtocolo !== undefined && request.nuAnoProtocolo !== null && request.nuAnoProtocolo > 0) {
            params = params.set('nuAnoProtocolo', String(request.nuAnoProtocolo));
        }

        return this.http.get<ProtocoloSelecaoResponse[]>(`${this.PATH}/pesquisar`, { params, context });
    }
}
